<style>
  /* th.mat-header-cell,
  td.mat-cell {
    padding-right: 22px;
  } */
  .w-90 {
    width: 90%;
    margin: auto;
  }
  .table-responsive {
    display: block;
    width: 100%;
    overflow-x: auto;
  }
  .table-responsive .mat-table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 1rem;
    display: table;
    border-collapse: collapse;
    margin: 0px;
  }
  .table-responsive .mat-row,
  .table-responsive .mat-header-row {
    display: table-row;
  }
  .table-responsive .mat-cell,
  .table-responsive.mat-header-cell {
    word-wrap: initial;
    display: table-cell;
    padding: 0px 8px;
    line-break: unset;
    width: auto;
    white-space: nowrap;
    overflow: hidden;
    vertical-align: middle;
  }

  .w-75 {
    max-width: 75px;
  }
  .w-130 {
    max-width: 130px;
  }
  button {
    margin-top: 17px;
    background: none;
    border: white;
    width: 100%;
  }
  th.mat-header-cell,
  td.mat-cell {
    padding-right: 20px;
    line-height: 1.2;
  }
  .mat-table {
    overflow-x: scroll;
  }

  .mat-row,
  .mat-header-row {
    min-width: 800px;
  }
  .mat-tab-body-content {
    overflow: hidden !important;
  }
  .admin-profile-hide {
    display: none;
  }
</style>
<app-common-header></app-common-header>

<div class="w-90 mb-5 mt-5">
  <mat-tab-group>
    <mat-tab label="Customer Dashboard">
      <div class="mat-elevation-z8">
        <app-admin-utility-report></app-admin-utility-report>
      </div>
    </mat-tab>
    <mat-tab label="Provider Contact Info">
      <div class="mat-elevation-z8">
        <app-hg-energy-providers-utility-info></app-hg-energy-providers-utility-info>
      </div>
    </mat-tab>
    <mat-tab label="TDU Rates">
      <div class="mat-elevation-z8">
        <app-hg-energy-providers-tdu-rates></app-hg-energy-providers-tdu-rates>
      </div>
    </mat-tab>
    <mat-tab label="Prepaid Providers">
      <div class="mat-elevation-z8">
        <app-admin-utility-pre-providers></app-admin-utility-pre-providers>
      </div>
    </mat-tab>
    <!-- <mat-tab label="Affliate" onclick="Redirect('hg-admin-promocode-list')">
      <div class="mat-elevation-z8">
       
      </div>
    </mat-tab>
    <mat-tab label="Promo Codes" onclick="Redirect('hg-admin-promocode-list')">
      <div class="mat-elevation-z8">
       
      </div>
    </mat-tab> -->
  </mat-tab-group>
  <!-- <a  onclick="Redirect('hg-admin-affiliate-list')">
    Affiliate
  </a> -->
</div>
